import { useEffect } from "react";
import { SITE_NAME } from "./Constants";

// Sets the browser tab title, e.g. "Night Bus Groove · Music Collaboration Platform". With no
// title (or while it's still loading) the tab shows just the site name.
const usePageTitle = (title?: string | null) => {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  }, [title]);
};

export default usePageTitle;
